var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',[_c('template',{slot:"header"},[_c('h5',{staticClass:"h3 mb-0"},[_vm._v(_vm._s(_vm.avaliationItem.name))])]),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('AvaliationNumberChart',{attrs:{"avaliation-item":_vm.avaliationItem,"chart-data":_vm.chartData}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }